import { makeStyles } from '@mui/styles';

const styles = makeStyles((theme) => ({
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: 'auto'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  runActionContainer: {
    marginLeft: '-8px'
  },
  dateSwiftContainer: {
    marginLeft: '-15px'
  },
  aspectRatioContainer: {
    marginLeft: '-10px',
  },
  piechartContainer: {
    marginLeft: '-17px',
  },
  dateTimePicker: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    alignSelf: 'flex-start',
  },
  divisionContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '16px'
  },
  divisionText: {
    color: '#000',
    fontWeight: 'bold',
    marginRight: '14px'
  },
  dateText: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#000'
  }
}));

export default styles;
